'use strict';

var EditWan = require('actionGroups/editWan/EditWan');

module.exports = {
  Model: EditWan,
};
